/* eslint-disable import/no-extraneous-dependencies */
import * as React from 'react';
import Footer from './footer';
import Navigation from './navigation';

function Layout({ children }) {
  return (
    <div className="global-wrapper">
      <Navigation />
      <main>{children}</main>
      <Footer />
    </div>
  );
}

export default Layout;
